/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const PaymentLinkStatus = {
  Active: "active",
  Used: "used",
  Disabled: "disabled",
  Expired: "expired",
} as const;
export type PaymentLinkStatus = ClosedEnum<typeof PaymentLinkStatus>;

/** @internal */
export const PaymentLinkStatus$inboundSchema: z.ZodNativeEnum<
  typeof PaymentLinkStatus
> = z.nativeEnum(PaymentLinkStatus);
/** @internal */
export const PaymentLinkStatus$outboundSchema: z.ZodNativeEnum<
  typeof PaymentLinkStatus
> = PaymentLinkStatus$inboundSchema;
